module.exports = __webpack_public_path__ + "static/media/adhd.ea54dad1.svg";